import { memo, forwardRef, FC } from 'react'
import { Select } from '@chakra-ui/react'

import { DynamicFieldProps } from '../..'

const BooleanFilterField: FC<DynamicFieldProps> = forwardRef<any, DynamicFieldProps>(({ name, onChange, ...props }, ref) => {
  return (
    <Select name={name} ref={ref} onChange={onChange} {...props}>
      <option value="">Sem valor</option>
      <option value="Sim">Sim</option>
      <option value="Não">Não</option>
    </Select>
  )
})

export default memo(BooleanFilterField)
